export default {
    url: '',
    template: '<forms-questions-pools-pool-list question-pool="vm.questionPool"></forms-questions-pools-pool-list>',
    resolve: {
        questionPool (QuestionPoolResource, $stateParams) {
            return QuestionPoolResource.get({ id: $stateParams.poolId }).$promise;
        }
    },
    controller (questionPool) {
        this.questionPool = questionPool;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/questions/pools/pool/list/index.js